// Func = limiting Scope for this file
var lastScrollTop = 0;
let windowWidth = window.innerWidth;
let windowHeight = window.innerHeight;


if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const burgerBtn = document.querySelector('.js-menu-burger');
const menuContainer = document.querySelector('.js-menu-container');
const burgerLinks = document.querySelectorAll('.js-menu-container a');
const burgerClose = document.querySelector('.js-menu-container_close');
const menuMain = menuContainer.querySelector('.menu-main');


(function(){

	let RFP_FORM = document.querySelector('#form_id-5043');
    if( RFP_FORM ){
        RFP_FORM.querySelector( "#" + RFP_FORM.id + "-yes-signup-formemail-signup" ).checked = true;
		RFP_FORM.querySelector( "#" + RFP_FORM.id + "-yes-signup-formemail-signup" ).parentElement.classList.add('hidden');
    }

	if(document.querySelectorAll('.btn').length > 0){
		document.querySelectorAll('.btn').forEach( btn => {
			btn.setAttribute('data-text', btn.textContent);
			if(btn.querySelector('span') === null){
				let span = document.createElement('span');
				span.innerHTML = btn.innerHTML;
				btn.innerHTML = '';
				btn.appendChild(span);
				
			}
		})
	}

	//cms form animation
	if(document.querySelectorAll('.form-module__field').length > 0){
		document.querySelectorAll('.form-module__field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}
	if(document.querySelectorAll('.field').length > 0){
		document.querySelectorAll('.field').forEach( field => {
			if(field.querySelector('input')){
				field.querySelector('input').addEventListener('focus',() =>{field.classList.add('focused')})
			}
			if(field.querySelector('select')){
				field.querySelector('select').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
			if(field.querySelector('textarea')){
				field.querySelector('textarea').addEventListener('focus', ()=> { field.classList.add('focused')})
			}
		});
	}

	const formModule = document.querySelectorAll('.form-module-wrapper form');
	if(formModule){
		formModule.forEach(function(form) {
			if(form.querySelector('h2')) {
				form.querySelector('h2').classList.add('animate-fade', 'bottom');
			}
		});
	}


    window.onload = function() {

		if(document.querySelector('.no-hero-img') || document.querySelector('#attractions') || document.querySelector('#gallery-flex')){
			document.querySelector('header').classList.add('down');
		} else {
			scrollW();
			window.addEventListener('scroll', function(){
				scrollW();
			})
		}

		if(document.querySelector('.js-menu-burger')){

			burgerLinks.forEach(el => el.setAttribute('tabindex', '-1'));

			burgerBtn.addEventListener('click', (e) => {
				e.preventDefault();
				menuContainer.classList.add('open');
				burgerLinks.forEach(el => el.setAttribute('tabindex', '0'));
				document.body.classList.add('no-scroll', 'burger-open');
			})
			
			burgerClose.addEventListener('click', () => {
				menuContainer.classList.remove('open');
				burgerLinks.forEach(el => el.setAttribute('tabindex', '-1'));
				document.body.classList.remove('no-scroll', 'burger-open');
			})

			document.addEventListener('click', (e) => {
				if (
					menuContainer.classList.contains('open') &&
					!menuMain.contains(e.target) &&
					!burgerBtn.contains(e.target)
				) {
					menuContainer.classList.remove('open');
					burgerLinks.forEach(el => el.setAttribute('tabindex', '-1'));
				}
			});
		}
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if(!document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.add('down');
		}
		
	} else {
		if(document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = location.pathname =='/' ? offset(document.querySelector(target)).top - 40 :  offset(document.querySelector(target)).top - 200;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

//keyboard focus accessibility 
const focusableSelector = `
  a[href],
  button,
  input,
  textarea,
  select,
  [tabindex]:not([tabindex="-1"])
`;

function disableFocusOutside(container, key) {
	const focusables = document.querySelectorAll(focusableSelector);
  
	focusables.forEach(el => {
	  if (container.contains(el)) return;
  
	  const attr = `data-prev-tabindex-${key}`;
  
	  if (!el.hasAttribute(attr)) {
		const prev = el.getAttribute('tabindex');
		el.setAttribute(attr, prev === null ? 'none' : prev);
	  }
  
	  el.setAttribute('tabindex', '-1');
	});
}
  
  
function restoreFocus(key) {
	const stored = document.querySelectorAll(`[data-prev-tabindex-${key}]`);
  
	stored.forEach(el => {
	  const prev = el.getAttribute(`data-prev-tabindex-${key}`);
  
	  if (prev === 'none') {
		el.removeAttribute('tabindex');
	  } else {
		el.setAttribute('tabindex', prev);
	  }
  
	  el.removeAttribute(`data-prev-tabindex-${key}`);
	});
}

if(screen.width > 600) {
	document.addEventListener('DOMContentLoaded', () => {

		const burgerObserver = new MutationObserver(() => {
			if (document.body.classList.contains("burger-open")) {
				disableFocusOutside(menuContainer, 'burger');
			} else {
				restoreFocus('burger');
			}
		});
		
		burgerObserver.observe(document.body, {
			attributes: true,
			attributeFilter: ["class"]
		}); 

		let allFormsToAddAriaLabel = document.querySelectorAll(`form.form-module, form.email-signup`);
		if( allFormsToAddAriaLabel ){
			allFormsToAddAriaLabel.forEach( form => {
				let submitAriaLabel = '';
				switch (form.id) {
					case 'form_id-5103':
						submitAriaLabel = 'submit media form'
						break;
	
					case 'form_id-5043':
						submitAriaLabel = 'submit request for proposal'
						break;
					case 'form_id-5115':
						submitAriaLabel = 'submit contact form'
						break;
	
					case 'email-signup':
						submitAriaLabel = 'subscribe to our email database'
						break;
	
					default:
						submitAriaLabel = 'Submit form'
						break;
				}
				form.querySelector('button[type="submit"]').setAttribute( 'aria-label', submitAriaLabel)
			} );
		}
	});
}

